module.exports = __webpack_public_path__ + "media/images/writer/user_extension_notification_mailer/voice-307961b5841dabe9cef809fdf3f9a542.png";